import { render, staticRenderFns } from "./footerView.vue?vue&type=template&id=d352135c&scoped=true"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"
import style0 from "./footerView.vue?vue&type=style&index=0&id=d352135c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d352135c",
  null
  
)

export default component.exports